<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRecording_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M2 3C.895 3 0 3.876 0 4.956v7.088C0 13.124.895 14 2 14h12c1.105 0 2-.876 2-1.956V4.956C16 3.876 15.105 3 14 3zm11.253 4.822h.997a1.9 1.9 0 0 0-.219-.697 1.7 1.7 0 0 0-.437-.515 1.9 1.9 0 0 0-.617-.322 2.5 2.5 0 0 0-.751-.11q-.616 0-1.107.274a1.97 1.97 0 0 0-.78.79q-.285.519-.286 1.258 0 .738.282 1.256.285.519.775.793.492.273 1.116.273.448 0 .803-.13.359-.132.615-.358.26-.227.412-.514a1.7 1.7 0 0 0 .194-.6l-.997-.005a.92.92 0 0 1-.342.563 1 1 0 0 1-.303.148q-.168.05-.367.05-.352 0-.621-.167a1.1 1.1 0 0 1-.42-.497q-.147-.329-.147-.812 0-.47.148-.8.147-.33.416-.502.27-.175.631-.175.201 0 .372.055a1 1 0 0 1 .305.16q.132.103.216.251a.9.9 0 0 1 .112.333M6.208 6.24v4.52H9.36v-.788H7.194v-1.08H9.19v-.787H7.194V7.028h2.157V6.24zM2 10.76V6.24h1.84q.528 0 .902.183.375.18.571.514.2.33.199.78 0 .45-.2.774a1.3 1.3 0 0 1-.624.513l.99 1.756H4.589l-.883-1.602h-.72v1.602zm.986-2.37h.67q.282 0 .469-.075a.55.55 0 0 0 .278-.226.7.7 0 0 0 .093-.373.7.7 0 0 0-.093-.38.57.57 0 0 0-.28-.233 1.2 1.2 0 0 0-.472-.082h-.665z"
        clip-rule="evenodd"
    />
</svg>
